import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles.css';

// Detect the SPA mount path from the URL so the build is portable across
// deployments (domain root, /site-starter/admin2/, /larana/admin2/, etc.).
function detectBasename(): string {
  if (import.meta.env.DEV) return '/';
  const m = window.location.pathname.match(/^(.*?\/admin2)(\/|$)/);
  return m ? m[1] : '/';
}
const basename = detectBasename();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
